<!-- 微信通知服务页面 -->
<template>
  <div class="content">
    <div class="service-section">
      <div class="section-title">
        <h1>微信通知服务</h1>
        <p>专业的微信消息推送解决方案</p>
      </div>

      <div class="feature-container">
        <div class="feature-item">
          <!-- <div class="feature-icon">📋</div> -->
          <div class="feature-text">
            <h3>多样性的微信通知模版</h3>
            <p>丰富的消息模板，满足各类业务场景</p>
          </div>
        </div>

        <div class="feature-item">
          <!-- <div class="feature-icon">🚀</div> -->
          <div class="feature-text">
            <h3>日发送上限为10万次</h3>
            <p>强大的消息处理能力，稳定可靠</p>
          </div>
        </div>

        <div class="feature-item">
          <!-- <div class="feature-icon">⚙️</div> -->
          <div class="feature-text">
            <h3>支持API调用以及定时任务</h3>
            <p>灵活的接入方式，满足不同需求</p>
          </div>
        </div>

        <div class="feature-item">
          <!-- <div class="feature-icon">📱</div> -->
          <div class="feature-text">
            <h3>支持自有公众号发送</h3>
            <p>使用您自己的公众号进行消息推送</p>
          </div>
        </div>
      </div>

      <div class="contact-section">
        <h3>联系技术人员配置</h3>
        <p class="contact-desc">扫描下方二维码获取技术支持</p>
        <div class="qr-code-container">
          <img src="../image/wx.jpg" alt="技术支持二维码" class="img-box animated-qr" />
          <div class="scan-line"></div>
        </div>
        <p class="qr-code-text">长按识别二维码-获取技术支持</p>
      </div>
    </div>

    <!-- <footer>
      <div>
        © YOLYN友灵｜沪ICP备2023035677号-4
        <br />Copyright © 2024 All Rights Reserved.
      </div>
    </footer> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.content {
  width: 100%;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);
  overflow-x: hidden;
}

/* 服务展示区域 */
.service-section {
  width: calc(100% - 40px);
  max-width: 800px;
  margin: 20px auto;
  padding: 30px 20px;
  background: linear-gradient(135deg, #fff 0%, #f0f9ff 100%);
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(52, 172, 243, 0.15);
  border: 1px solid rgba(52, 172, 243, 0.1);
}

.section-title {
  text-align: center;
  margin-bottom: 40px;

  h1 {
    font-size: 28px;
    color: #34acf3;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 2px;
    margin-bottom: 12px;
    text-shadow: 0 2px 4px rgba(52, 172, 243, 0.1);
  }

  p {
    color: #666;
    font-size: 16px;
    letter-spacing: 1px;
    margin: 0;
  }
}

/* 特性列表容器 */
.feature-container {
  max-width: 600px;
  margin: 0 auto 40px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  margin-bottom: 15px;
  background: #fff;
  border-radius: 15px;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: default;

  &:hover {
    transform: translateY(-2px);
    border-color: #34acf3;
    box-shadow: 0 6px 20px rgba(52, 172, 243, 0.15);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.feature-icon {
  font-size: 32px;
  line-height: 1;
  flex-shrink: 0;
  animation: iconFloat 3s ease-in-out infinite;
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.feature-text {
  flex: 1;

  h3 {
    font-size: 16px;
    color: #333;
    font-weight: 600;
    margin: 0 0 6px 0;
    letter-spacing: 0.5px;
  }

  p {
    font-size: 14px;
    color: #999;
    margin: 0;
    line-height: 1.5;
  }
}

/* 联系方式区域 */
.contact-section {
  text-align: center;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px dashed rgba(52, 172, 243, 0.2);

  h3 {
    font-size: 20px;
    color: #34acf3;
    font-weight: 600;
    margin-bottom: 8px;
    letter-spacing: 1px;
  }

  .contact-desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
  }
}

/* 二维码动画容器 */
.qr-code-container {
  position: relative;
  display: inline-block;
  margin: 20px auto;
  padding: 20px;
  background: linear-gradient(135deg, #fff 0%, #f0f9ff 100%);
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(52, 172, 243, 0.15);
  border: 2px solid rgba(52, 172, 243, 0.1);
}

.img-box {
  width: 200px;
  height: 200px;
  display: block;
  border-radius: 15px;
  position: relative;
  z-index: 2;
}

/* 二维码呼吸动画 */
.animated-qr {
  animation: qrBreathing 3s ease-in-out infinite;
}

@keyframes qrBreathing {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(52, 172, 243, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(52, 172, 243, 0.3);
  }
}

/* 扫描线动画 */
.scan-line {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #34acf3 50%,
    transparent 100%
  );
  animation: scanAnimation 2s linear infinite;
  z-index: 3;
  border-radius: 1px;
}

@keyframes scanAnimation {
  0% {
    top: 20px;
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    top: 220px;
    opacity: 1;
  }
}

.qr-code-text {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
  letter-spacing: 0.5px;
}

/* 底部 */
footer {
  padding: 80px 0 30px 0;
  text-align: center;
  line-height: 30px;

  div {
    padding-top: 30px;
    margin: 0 auto;
    width: 80%;
    border-top: 1px dotted rgba(52, 172, 243, 0.3);
    color: #a9a9a9;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .service-section {
    width: calc(100% - 20px);
    padding: 20px 15px;
    margin: 10px auto;
  }

  .section-title h1 {
    font-size: 24px;
    letter-spacing: 1px;
  }

  .section-title p {
    font-size: 14px;
  }

  .feature-item {
    padding: 15px;
    gap: 12px;
  }

  .feature-icon {
    font-size: 28px;
  }

  .feature-text h3 {
    font-size: 15px;
  }

  .feature-text p {
    font-size: 13px;
  }

  .qr-code-container {
    padding: 15px;
  }

  .img-box {
    width: 180px;
    height: 180px;
  }

  .contact-section h3 {
    font-size: 18px;
  }
}
</style>
